import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PretendardText from "../atoms/text/pretendardText";

/**
 * route로 이동하지 않는 페이지네이션 컴포넌트
 */
function Pagination2({
  route,
  queryString,
  totalPages,
  currentPage,
  setCurrentPage,
  rangeSize,
  first,
  last,
  style,
}) {
  const navigate = useNavigate();

  const pageList = useMemo(() => {
    const pageGroup = Math.ceil(currentPage / rangeSize);

    let firstNumber = pageGroup * rangeSize - (rangeSize - 1);
    if (firstNumber <= 0) {
      firstNumber = 1;
    }

    let lastNumber = pageGroup * rangeSize;
    if (lastNumber > totalPages) {
      lastNumber = totalPages;
    }

    const pageList = [];
    for (let i = firstNumber; i <= lastNumber; i++) {
      pageList.push(i);
    }

    return pageList;
  }, [totalPages, currentPage, rangeSize]);

  return (
    <>
      {pageList.length > 0 ? (
        <>
          <PagenationWrapper style={style}>
            <img
              src="/assets/admin/icons/ico_pagination_left.svg"
              alt="arrow-left"
              style={{
                width: 28,
                height: 28,
                cursor: "pointer",
              }}
              onClick={() => {
                if (first || Number(currentPage) === 1) {
                  return;
                }

                setCurrentPage(Number(currentPage) - 1);
              }}
            />
            <PagenationNumWrapper>
              {pageList.map((item, index) => {
                return (
                  <PagenationNum
                    key={index}
                    style={{
                      background: Number(currentPage) === item ? "#272829" : "",
                    }}
                    onClick={() => {
                      setCurrentPage(Number(item));
                    }}
                  >
                    {item}
                  </PagenationNum>
                );
              })}
            </PagenationNumWrapper>
            <img
              src="/assets/admin/icons/ico_pagination_right.svg"
              alt="arrow-right"
              style={{
                width: 28,
                height: 28,
                cursor: "pointer",
              }}
              onClick={() => {
                if (last || Number(currentPage) === totalPages) {
                  return;
                }

                setCurrentPage(Number(currentPage) + 1);
              }}
            />
          </PagenationWrapper>
        </>
      ) : null}
    </>
  );
}

export default Pagination2;

const PagenationWrapper = styled.div.attrs((props) => {})`
  margin-top: 40px;
  width: 1044px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const PagenationNumWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const PagenationNum = styled(PretendardText).attrs((props) => {})`
  color: #f3f3f3;
  display: flex;
  font-weight: 700;
  line-height: 28px;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #b8bfc4;
`;
